// extracted by mini-css-extract-plugin
export default {"OutlineButton":"OutlineButton_OutlineButton__gedsm"};